import React from "react";
 import { useParams } from "react-router-dom";
import StablePrime from "../../components/Tables/StablePrime";



function FourMReportStableDir({ setPageHeader }) {
  const { docNo } = useParams();
  setPageHeader("4M Record");
  return (
    <div>
      <StablePrime editSingleColumn={true} url="/bsl/fourmsession" data={{sdlCode:docNo}} identity="" />
    </div>
  );
}

export default FourMReportStableDir;
